import "../../sass/core.sass";

import { ApolloProvider } from "@apollo/client";
import client from "../helpers/apollo-client";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Provider } from "react-redux";
import React from "react";
import DownloadHistory from "../components/download-history";
import InvoiceList from "../components/invoice-list";
import InvoiceEdit from "../components/invoice-edit";
import InfiniteDeniedUploads from "../components/dashboard/inactive-uploads/infinite-denied-uploads";
import InfinitePendingUploads from "../components/dashboard/inactive-uploads/infinite-pending-uploads";
import InfiniteCollections from "../components/dashboard/collections/infinite-collections";
import SignupPage from "../components/auth/signup/signup-page";
import Modal from "./modal";
import Toasts from "./toasts";
import PrepaidBalancePage from "../components/PrepaidBalancePage/index";

import { LegacyUserContextProvider } from "contexts/CurrentUserContext";

import store from "../stores/reduxStore";

class NounProject extends React.Component {
    constructor(props) {
        super(props);

        if (props.args) {
            window._nounConfig.args = props.args;
        }
    }

    render() {
        const SignupPageComponent = () => {
            const { signupType, plans, next } = this.props.args;
            return (
                <SignupPage signupType={signupType} plans={plans} next={next} />
            );
        };

        let { args } = this.props;

        return (
            <ApolloProvider client={client}>
                <Provider store={store}>
                    <LegacyUserContextProvider>
                        <div style={{ width: "100%" }}>
                            <Router>
                                <Routes>
                                    <Route
                                        path="/accounts/signup/"
                                        element={<SignupPageComponent />}
                                    />
                                    <Route
                                        path="/accounts/signup/:signupType/"
                                        element={<SignupPageComponent />}
                                    />
                                    <Route
                                        path="/:username/settings/invoices/:chargeId/edit/"
                                        element={<InvoiceEdit />}
                                    />
                                    <Route
                                        path="/:username/settings/invoices/:chargeId?/"
                                        element={<InvoiceList />}
                                    />
                                    <Route
                                        path="/:username/settings/invoices/"
                                        element={<InvoiceList />}
                                    />
                                    <Route
                                        path="/:username/settings/icon-history/"
                                        element={<DownloadHistory />}
                                    />
                                    <Route
                                        path="/:username/uploads/denied/"
                                        element={<InfiniteDeniedUploads />}
                                    />
                                    <Route
                                        path="/:username/uploads/pending/"
                                        element={<InfinitePendingUploads />}
                                    />
                                    <Route
                                        path="/:username/collections/"
                                        element={<InfiniteCollections args={this.props.args} />}
                                    />
                                    <Route
                                        path="/:username/settings/prepaid-balance"
                                        element={<PrepaidBalancePage />}
                                    />
                                </Routes>
                                <Modal />
                            </Router>
                            <Toasts />
                        </div>
                    </LegacyUserContextProvider>
                </Provider>
            </ApolloProvider>
        );
    }
}

export default NounProject;
